export default __webpack_public_path__ + "static/media/card-maestro.cb05e08a.svg";